// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
// import React from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SelectInline, { SelectInlineStyles } from "@store/Library/Components/Toolkit/SelectInline";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { useMemo } from "react";

interface OwnProps extends WidgetProps, ExpandStyles<ProductListSortSelectStyles> {
    labelPosition?: "top" | "left";
    label?: string;
    inline?: boolean;
    uid?: string;
}
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    pagination: getProductListDataViewProperty(state, "pagination"),
});

const mapDispatchToProps = {
    addProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps; // Starter Custom Code

export interface ProductListSortSelectStyles {
    select?: SelectPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
}

export const sortSelectStyles: ProductListSortSelectStyles = {
    // Starter Removed - select
};

// Starter Removed - styles

const ProductListSortSelect = ({
    addProductFilters,
    pagination,
    // Starter Custom Code
    label,
    labelPosition = "left",
    inline,
    uid,
    extendedStyles,
    overridedStyles,
}: Props) => {
    /* Starter Custom Code - Start */
    const styles = useExpandProps(sortSelectStyles, extendedStyles, overridedStyles);
    const selectInlineStyles = useMemo((): SelectInlineStyles => styles, [styles]);
    const trackSearchSorted = ga.use.trackSearchSorted();
    /* Starter Custom Code - End */

    if (!pagination) {
        return null;
    }

    const onChangeSortHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        addProductFilters({ sort: event.currentTarget.value });

        /* Starter Custom Code - Start */
        trackSearchSorted({
            sort_type: pagination.sortOptions.find(x => x.sortType === event.currentTarget.value)?.displayName || "",
        });
        /* Starter Custom Code - End */
    };

    /* Starter Custom Code - Start */
    const SelectComponent = inline ? SelectInline : Select;
    const selectStyles = inline ? {} : styles.select;
    /* Starter Custom Code - End */

    return (
        <SelectComponent // Starter Custom Code
            {...selectStyles} // Starter Custom Code
            extendedStyles={selectInlineStyles} // Starter Custom Code
            // label={translate("Sort by")} //Foundation
            value={pagination.sortType}
            // labelPosition="left" //Foundation
            preventEllipsis={true}
            onChange={onChangeSortHandler}
            data-test-selector="productListSortSelect"
            uid={uid || "productListSortSelect"} // Starter Custom Code
        >
            {pagination.sortOptions.map(sortOption => (
                <option key={sortOption.sortType} value={sortOption.sortType}>
                    {sortOption.displayName}
                </option>
            ))}
        </SelectComponent>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListSortSelect),
    definition: {
        group: "Product List",
        displayName: "Sort Select",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
